import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MoreDetailsComponent } from './more-details/more-details.component';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { VerifyHeaderComponent } from './verify-header/verify-header.component';
import { NotificationModalComponent } from './notification-modal/notification-modal.component';
import { LoadingSpinnerComponent } from './loading-spinner/loading-spinner.component';
import { MainHeaderComponent } from './main-header/main-header.component';
import { VegboostModalComponent } from './vegboost-modal/vegboost-modal.component';
import { SuperLikeModalComponent } from './superlike-modal/superlike-modal.component';
import { ComplimentModalComponent } from './compliment-modal/compliment-modal.component';
import { ShareModalComponent } from './share-modal/share-modal.component';
import { AvocadoModalComponent } from './avocado-modal/avocado-modal.component';
import { TopFilterComponent } from './top-filter/top-filter.component';
import { MatchesCarouselComponent } from './matches-carousel/matches-carousel.component';
import { NewLikesIconComponent } from './new-likes-icon/new-likes-icon.component';
import { InfoButtonComponent } from './info-button/info-button.component';
import { LikedBySelectedComponent } from './liked-by-selected/liked-by-selected.component';
import { GenericHeaderComponent } from './generic-header/generic-header.component';
import { ShareProfileComponent } from './share-profile/share-profile.component';
import { ProfileSharePerCarrotsComponent } from './profile-share-per-carrots/profile-share-per-carrots.component';
import { ChangeProfilePhotoComponent } from './change-profile-photo/change-profile-photo.component';
import { ValidationCompletedComponent } from './validation-completed/validation-completed.component';
import { NewPhotoNotApprovedComponent } from './new-photo-not-approved/new-photo-not-approved.component';
import { NewPhotoValidationComponent } from './new-photo-validation/new-photo-validation.component';
import { ProfileAlreadyValidatedComponent } from './profile-already-validated/profile-already-validated.component';
import { TermsComponent } from './terms/terms.component';
import { ValidateProfileComponent } from './validate-profile/validate-profile.component';
import { NotAvailableComponent } from './not-available/not-available.component';
import { SliderControlComponent } from './slider-control/slider-control.component';
import { WebAdComponent } from './web-ad.component';
import { LazyLoadDirective } from '../directives/lazy-load.directive';
import { PromotionPopupModalComponent } from './promotion-popup-modal/promotion-popup-modal.component';
import { OnboardingWelcomeBackComponent } from './onboarding-welcome-back/onboarding-welcome-back.component';

@NgModule({
  declarations: [InfoButtonComponent,
    MoreDetailsComponent,
    VerifyHeaderComponent,
    LoadingSpinnerComponent,
    MainHeaderComponent,
    VegboostModalComponent,
    SuperLikeModalComponent,
    ComplimentModalComponent,
    ShareModalComponent,
    AvocadoModalComponent,
    NotificationModalComponent,
    TopFilterComponent,
    MatchesCarouselComponent,
    LikedBySelectedComponent,
    NewLikesIconComponent,
    GenericHeaderComponent,
    ShareProfileComponent,
    ProfileSharePerCarrotsComponent,
    ChangeProfilePhotoComponent,
    ValidationCompletedComponent,
    NewPhotoNotApprovedComponent,
    NewPhotoValidationComponent,
    ProfileAlreadyValidatedComponent,
    TermsComponent,
    ValidateProfileComponent,
    NotAvailableComponent,
    SliderControlComponent,
    WebAdComponent,
    LazyLoadDirective,
    PromotionPopupModalComponent,
    OnboardingWelcomeBackComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule
  ],
  exports: [
    InfoButtonComponent,
    MoreDetailsComponent,
    VerifyHeaderComponent,
    LoadingSpinnerComponent,
    MainHeaderComponent,
    VegboostModalComponent,
    SuperLikeModalComponent,
    ComplimentModalComponent,
    ShareModalComponent,
    AvocadoModalComponent,
    TopFilterComponent,
    MatchesCarouselComponent,
    LikedBySelectedComponent,
    NewLikesIconComponent,
    GenericHeaderComponent,
    ShareProfileComponent,
    ProfileSharePerCarrotsComponent,
    ChangeProfilePhotoComponent,
    ValidationCompletedComponent,
    NewPhotoNotApprovedComponent,
    NewPhotoValidationComponent,
    ProfileAlreadyValidatedComponent,
    TermsComponent,
    ValidateProfileComponent,
    IonicModule,
    TranslateModule,
    NotAvailableComponent,
    SliderControlComponent,
    WebAdComponent,
    LazyLoadDirective,
    PromotionPopupModalComponent,
    OnboardingWelcomeBackComponent]
})
export class SharedModule { }
